import { ReactElement } from "react"

import { LCT_METADATA_DISPATCHER } from "./lctMetadataDispatcher"
import { UNKNOWN_STATUS } from "../../../constants/generalConstants"
import AppChip from "../../dataDisplay/chips/appChip"
import AppTooltip from "../../helper/appTooltip"

interface ILctChipProps {
    lct: string
    sx?: Record<string, number>
}

/**
 * Returns chip / pill for each recognised low carbon technology. Maps each
 * LCT abbreviation to a user friendly term.
 * @example
 * <StatusChip status="Compliant" />
 */
const LctChip = ({ lct, sx }: ILctChipProps): ReactElement => {
    const unknownConfig = LCT_METADATA_DISPATCHER[UNKNOWN_STATUS]
    const lctConfig = LCT_METADATA_DISPATCHER[lct] || unknownConfig
    return (
        <AppTooltip title={lctConfig.tooltip}>
            <span>
                <AppChip
                    label={lctConfig.label || lct}
                    sx={sx}
                    variant="outlined"
                    color="primary"
                />
            </span>
        </AppTooltip>
    )
}

LctChip.defaultProps = {
    sx: null,
}

export default LctChip
